'use strict';

const init = () => {
    const cursor = document.getElementById('custom-cursor')
    const isTouch = document.body.classList.contains('touch')

    // remember where the cursor lives initially
    const _originalParent = cursor?.parentElement || document.body

    // move the cursor element into a given parent (used for fullscreen)
    const _moveCursorTo = (parent) => {
        if (!parent) return
        if (cursor.parentElement !== parent) {
            parent.appendChild(cursor)
        }
    }

    // when an element enters the top-layer fullscreen, only its subtree is rendered above others
    // so we must move the custom cursor inside that subtree; when exiting, move it back
    const _handleFullscreenChange = () => {
            const fsEl = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement
            if (fsEl) {
                _moveCursorTo(fsEl)
            } else {
                _moveCursorTo(_originalParent)
            }
        }

        // listen for all vendor fullscreen change events
    ;['fullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'].forEach((evt) => {
        document.addEventListener(evt, _handleFullscreenChange)
    })

    if (!isTouch) {
        document.addEventListener('mousemove', (event) => {
            if (cursor.classList.contains('hidden')) {
                cursor.classList.remove('hidden')
            }

            cursor.style.top = `${event.clientY}px`
            cursor.style.left = `${event.clientX}px`
        })

        document.addEventListener('mouseleave', () => {
            cursor.style.opacity = '0'
        })

        document.addEventListener('mouseenter', () => {
            cursor.style.opacity = '1'
        })

        document.addEventListener('mouseover', (event) => {
            const component = event.target.closest('[data-cursor-type="circle"]')
            if (component) {
                removeCursorClasses(cursor)
                cursor.classList.add(component.dataset.cursorColor + '-cursor')
            }
        })

        document.addEventListener('mouseout', (event) => {
            const component = event.target.closest('[data-cursor-type="circle"]')
            if (component) {
                removeCursorClasses(cursor)
            }
        })

        document.querySelectorAll('[data-cursor-type="big-with-text"]').forEach((component) => {
            component.addEventListener('mouseenter', () => {
                cursor.classList.add('big-cursor')
                document.body.classList.add('big-cursor-visible')
                cursor.classList.add('big-cursor-' + component.dataset.cursorColor)

                if (component.dataset.cursorText && component.dataset.cursorShowArrow !== 'true') {
                    cursor.getElementsByTagName('span')[0].innerText = component.dataset.cursorText
                } else if (component.dataset.cursorShowArrow === 'true') {
                    cursor.getElementsByTagName('span')[0].classList.add('show-arrow')
                }
            })

            component.addEventListener('mouseleave', () => {
                cursor.classList.remove('big-cursor')
                document.body.classList.remove('big-cursor-visible')
                cursor.classList.remove('big-cursor-' + component.dataset.cursorColor)

                if (component.dataset.cursorText && component.dataset.cursorShowArrow !== 'true') {
                    cursor.getElementsByTagName('span')[0].innerHTML = ''
                } else if (component.dataset.cursorShowArrow === 'true') {
                    cursor.getElementsByTagName('span')[0].classList.remove('show-arrow')
                }
            })
        })

        // Change cursor to gray on interactive elements
        document.addEventListener('mouseover', (e) => {
            if (e.target.closest('.jonnitto-prettyembed--video, .jonnitto-prettyembed-lightbox__content, .main-menu > li.contact > a, .form-navigation > ul > li.submit > button, .btn, .tarteaucitronAllow, .jonnitto-prettyembed-gdpr__button--accept')) {
                document.body.classList.remove('green-cursor')
                document.body.classList.add('gray-cursor')
            }
        })

        // Restore green cursor when leaving interactive elements
        /*document.addEventListener('mouseout', (e) => {
            if (e.target.closest('.jonnitto-prettyembed--video, .jonnitto-prettyembed-lightbox__content, .main-menu > li.contact > a, .form-navigation > ul > li.submit > button, .btn, .tarteaucitronAllow, .jonnitto-prettyembed-gdpr__button--accept')) {
                document.body.classList.remove('gray-cursor')
                document.body.classList.add('green-cursor')
            }
        })*/

        // hide custom cursor on Youtube iframe
        document.querySelectorAll('.jonnitto-prettyembed--youtube').forEach((youtubeVideo) => {
            youtubeVideo.querySelector('.jonnitto-prettyembed-button--play').addEventListener('click', () => {
                // Don't hide cursor immediately - wait for iframe to appear
                const checkForIframe = () => {
                    const iframe = youtubeVideo.querySelector('iframe')
                    if (iframe) {
                        // Only hide cursor when iframe is actually present and hovered
                        youtubeVideo.addEventListener('mousemove', () => {
                            if (iframe.matches(':hover')) {
                                cursor.classList.add('instant-hide')
                            }
                        })

                        iframe.addEventListener('mouseleave', () => {
                            cursor.classList.remove('instant-hide')
                        })
                    } else {
                        // Iframe not ready yet, check again in 100ms
                        setTimeout(checkForIframe, 100)
                    }
                }

                checkForIframe()
            })
        })

        // ensure correct placement on load
        _handleFullscreenChange()
    }
}

const removeCursorClasses = (cursor) => {
    cursor.classList.forEach((className) => {
        if (className.endsWith('-cursor')) {
            cursor.classList.remove(className)
        }
    })
}

const resetCursor = () => {
    const cursor = document.getElementById('custom-cursor')

    cursor.classList.remove('big-cursor')
    cursor.classList.remove('big-cursor-gray')

    cursor.getElementsByTagName('span')[0].innerHTML = ''
    cursor.getElementsByTagName('span')[0].classList.remove('show-arrow')
}

export default {init, resetCursor}
